import { Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { AnnouncementService, SeenAnnouncementsService } from '@insolution/announcement-data-access';
import { IconModule } from '@insolution/core-data-access';
import { Announcement, EAnnouncementAppType } from '@insolution/graphql-data-access';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

import { getActiveAnnouncements } from '../get-active-announcements';

@Component({
  selector: 'lib-reset-announcements-button',
  imports: [IconModule, TranslatePipe, NgbTooltip],
  templateUrl: './reset-announcements-button.html',
  styleUrl: './reset-announcements-button.scss',
})
export class ResetAnnouncementsButton {
  public appType = input.required<EAnnouncementAppType>();

  private announcementService = inject(AnnouncementService);
  private seenAnnouncementsService = inject(SeenAnnouncementsService);

  private announcements = toSignal(this.announcementService.watchAnnouncements$(), { initialValue: [] });

  protected seenAnnouncements = computed<Announcement[]>(() => {
    const seenAnnouncementIds = this.seenAnnouncementsService.seenAnnouncementIds();

    return getActiveAnnouncements(this.announcements(), this.appType()).filter((announcement) =>
      seenAnnouncementIds.includes(announcement.id)
    );
  });

  protected onResetSeenAnnouncements(): void {
    this.seenAnnouncementsService.resetSeenAnnouncements();
  }
}
